/**
 * テーブル列ソートの共有語彙（方向 + 比較関数）。reliability のドリルダウン、KPI 詳細、ops キューが
 * 同じ規則で並び替えるための単一 source。もとは `components/features/reliability/sort-utils.ts` に
 * あったが、`lib/` 側（ops キュー）からも使うようになり `lib → components` の逆向き依存になるため
 * ここへ引き上げた。`SortDir` の定義も同じ理由で `KpiDetailModal/SortableHeader.tsx` から移し、
 * 既存の import 経路は SortableHeader の re-export で維持している。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business テーブル列ソートの共有語彙。並び順の方向と、null/undefined を方向に関わらず末尾へ寄せる比較規則を全テーブルで共通化する
 * @graph-connects none
 */

/** 並び順の方向。 @graph-connects none */
export type SortDir = 'asc' | 'desc';

/**
 * テーブル列の値を比較する。null/undefined はソート方向に関わらず末尾、数値同士は数値比較、
 * それ以外は日本語ロケールの文字列比較を行う。
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business テーブルソート用の比較関数。null/undefined はソート方向に関わらず末尾、数値同士は数値比較、それ以外は日本語ロケールの文字列比較を行う
 * @graph-connects none
 */
export function compareTableValues(
  av: string | number | null | undefined,
  bv: string | number | null | undefined,
  dir: SortDir,
): number {
  if (av == null && bv == null) return 0;
  if (av == null) return 1;
  if (bv == null) return -1;
  const cmp =
    typeof av === 'number' && typeof bv === 'number'
      ? av - bv
      : String(av).localeCompare(String(bv), 'ja');
  if (cmp === 0) return 0;
  return dir === 'asc' ? cmp : -cmp;
}
